import React from "react";
import { OuterContainer } from "../../EventCreation/styles";
import ActionBar from "../../common/ActionBar";
import styled, { css } from "styled-components";
import theme from "../../../assets/theme";
import {
  Paper,
  Typography,
  Grid,
  useTheme,
  useMediaQuery,
  FormLabel,
} from "@material-ui/core";
import { Formik } from "formik";
import { PrimaryCTAButton } from "../../common/Buttons";
import FormField from "../FormInputs";
import COLORS from "../../../assets/Colors";
// import CardCount from "../../common/CardCount";
// import ReportsOne from "../CustomTable/ReportsOne";

const Reports = () => {
  const themes = useTheme();
  const isBigScreen = useMediaQuery(themes.breakpoints.up(640));
  /*
  
  const [dashboardCount, setDashboardCount] = useState({
    todaysEvent: 7,
    compltedEvents: 10,
    upcomingEvents: 380,
    activeCustomers: 38,
    averageParticipants: 45,
    registeredUsers: 90,
    liveInteractions: 650,
  });

  const badges = [
    {
      value: 7,
      label: "Today's Events",
      key: "todaysEvent",
    },
    {
      value: 5,
      label: "Completed Events",
      key: "compltedEvents",
    },
    {
      value: 5,
      label: "Upcoming Events",
      key: "upcomingEvents",
    },
    {
      value: 10,
      label: "Active Customers",
      key: "activeCustomers",
    },
    {
      value: 100,
      label: "Average Participants",
      key: "averageParticipants",
    },
    {
      value: 25,
      label: "Registered Users",
      key: "registeredUsers",
    },
    {
      value: 10,
      label: "Live Interactions",
      key: "liveInteractions",
    },
  ];

  */

  const input_items = [
    { name: "", label: "Companies Available", type: "select" },
  ];

  const input_items_one = [
    { name: "", label: "Companies Selected", type: "select" },
  ];

  const switch_items = [
    {
      name: "sendPolls",
      label: "Send Polls",
      type: "switch",
    },
    {
      name: "sendTickers",
      label: "Send Tickers",
      type: "switch",
    },
    {
      name: "viewRegistration",
      label: "View Registration",
      type: "switch",
    },
    {
      name: "uploadResources",
      label: "Upload Resources",
      type: "switch",
    },
    {
      name: "viewCommunicate",
      label: "View Communicate",
      type: "switch",
    },
    {
      name: "viewQuestions",
      label: "View Questions",
      type: "switch",
    },
    {
      name: "viewFeedback",
      label: "View Feedback",
      type: "switch",
    },
    {
      name: "viewPollResponse",
      label: "View Poll Response",
      type: "switch",
    },
    {
      name: "viewResourceAccessed",
      label: "View Resource Accessed",
      type: "switch",
    },
    {
      name: "approveRegistrants",
      label: "Ppprove Registrants",
      type: "switch",
    },
  ];

  const custom_buttons = [
    {
      label: "SAVE",
      color: "default",
    },
    {
      label: "SAVE & NEXT",
      color: "primary",
    },
    {
      label: "CLEAR FORM",
      color: "secondary",
    },
  ];

  const company_buttons = [
    {
      label: "Move to Selected >>",
      color: "default",
    },
    {
      label: "<< Remove from Selected",
      color: "primary",
    },
  ];

  const items = ["Company 1", "Company 2", "Company 4", "Company 6"];

  return (
    <OuterContainer disabled={false}>
      <ActionBar breadcrumbs={["Event Manager", "Reports"]} />
      {/* <CardCount dashboardCount={dashboardCount} cards={badges} /> */}
      {/* <ReportsOne /> */}
      <Container>
        <Formik
          initialValues={{
            availableCompanies: "",
            selectedCompanies: "",
            sendPolls: "",
            sendTickers: "",
            viewRegistration: "",
            uploadResources: "",
            viewCommunicate: "",
            viewQuestions: "",
            viewFeedback: "",
            viewPollResponse: "",
            viewResourceAccessed: "",
            approveRegistrants: "",
          }}
          enableReinitialize
          onSubmit={""}
          validateOnBlur
          validateOnChange
          validationSchema={""}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            setFieldValue,
          }) => (
            <FormContainer>
              <Container>
                <Paper elevation={3} style={{ padding: "16px" }}>
                  <Heading>Reports</Heading>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <GridLabel>Company Associated</GridLabel>
                    <Grid container spacing={2} style={{ marginTop: "16px" }}>
                      {input_items.map((item, index) => (
                        <Grid
                          item
                          xs={isBigScreen ? 4 : 12}
                          key={item.name}
                          // style={styles.gridItem}
                        >
                          {/* <SwitchLabel>{item.label}</SwitchLabel> */}
                          <FormLabel
                            style={{
                              fontFamily: theme.fonts.primaryFontSemiBold,
                              color: "#A6AEBF",
                              marginLeft: "32px",
                            }}
                          >
                            {item.label}
                          </FormLabel>

                          <ListContainer>
                            {items.map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  ...listStyles.listItem,
                                  // backgroundColor:
                                  //   selectedItem === item ? "#d3d3d3" : "#fff",
                                }}
                                // onClick={() => handleClick(item)}
                              >
                                {item}
                              </div>
                            ))}
                          </ListContainer>
                          {/* <FormControlLabel
                            labelPlacement="top"
                            label={
                              <SwitchLabel {...{ isBigScreen }} width={"180px"}>
                                {item.label}
                              </SwitchLabel>
                            }
                            control={
                              <CustomSelect
                                white
                                style={{
                                  width: isBigScreen ? "250px" : "220px",
                                }}
                                menuItemValues={[
                                  {
                                    name: "none",
                                    label: "None",
                                    value: "none",
                                  },
                                ]}
                              />
                            }
                          /> */}
                        </Grid>
                      ))}
                      <GridButtons>
                        {company_buttons.map((button) => (
                          <PrimaryCTAButton
                            style={{
                              marginBottom: "5px",
                            }}
                          >
                            {button.label}
                          </PrimaryCTAButton>
                        ))}
                      </GridButtons>
                      {input_items_one.map((item, index) => (
                        <Grid item key={item.name} xs={isBigScreen ? 4 : 12}>
                          <FormLabel
                            style={{
                              fontFamily: theme.fonts.primaryFontSemiBold,
                              color: "#A6AEBF",
                              marginLeft: "32px",
                            }}
                          >
                            {item.label}
                          </FormLabel>

                          <ListContainer>
                            {["Company 3", "Company 5"].map((item, index) => (
                              <div
                                key={index}
                                style={{
                                  ...listStyles.listItem,
                                  // backgroundColor:
                                  //   selectedItem === item ? "#d3d3d3" : "#fff",
                                }}
                                // onClick={() => handleClick(item)}
                              >
                                {item}
                              </div>
                            ))}
                          </ListContainer>
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                  <Paper
                    elevation={3}
                    style={{
                      padding: 16,
                      border: "1px solid #e1e3ee",
                      marginTop: "15px",
                      marginBottom: "15px",
                    }}
                  >
                    <GridLabel>Event Admin Access</GridLabel>
                    <Grid
                      container
                      item
                      xs={12}
                      spacing={3}
                      style={{ padding: 16 }}
                    >
                      {switch_items.map((item, idx) => (
                        <Grid
                          item
                          xs={isBigScreen ? 4 : 12}
                          key={item.name}
                          style={styles.gridItem}
                        >
                          <FormField
                            {...{ item, handleChange, values }}
                            direction={"row"}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </Paper>
                  <Grid item xs={12}>
                    <Grid
                      item
                      xs={12}
                      style={{
                        textAlign: "left",
                        marginTop: "20px",
                      }}
                    >
                      {custom_buttons.map((button) => (
                        <PrimaryCTAButton
                          style={{ width: "auto", marginLeft: 8 }}
                        >
                          {button.label}
                        </PrimaryCTAButton>
                      ))}
                    </Grid>
                  </Grid>
                </Paper>
              </Container>
            </FormContainer>
          )}
        </Formik>
      </Container>
    </OuterContainer>
  );
};

const styles = {
  container: {
    backgroundColor: "#A9A9A9", // gray background
    padding: "20px",
    borderRadius: "8px",
  },
  gridItem: {
    display: "flex",
    justifyContent: "space-between",
  },
  label: {
    fontWeight: "bold",
  },
};

const listStyles = {
  container: {
    width: "200px",
    // margin: "20px auto",
    textAlign: "center",
    fontFamily: "Arial, sans-serif",
  },
  listBox: {
    border: "1px solid #ccc",
    borderRadius: "5px",
    overflow: "hidden",
  },
  listItem: {
    padding: "10px",
    cursor: "pointer",
    userSelect: "none",
    textAlign: "left",
  },
};

export default Reports;

const Container = styled.div`
  padding: 20px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  & .delete {
    display: flex;
    cursor: pointer;
  }
  @media ${theme?.breakpoints?.sm_up} {
    // padding: 34px 43px;
  }
`;

const Heading = styled(Typography)(() => ({
  backgroundColor: "#00aeef",
  color: "#fff",
  padding: "8px",
  fontFamily: theme.fonts.primaryFontBold,
  borderRadius: "5px",
}));

const FormContainer = styled.form`
  /* width: 907px; */

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  @media ${theme?.breakpoints?.md_up} {
    width: 100%;
  }
`;

export const ButtonWrapper = styled.div`
  width: fit-content;
  @media ${theme?.breakpoints?.md_up} {
    justify-content: flex-start;
    display: flex;
    padding-bottom: 20px;
    padding-top: 7px;
  }
`;

export const DeleteIcon = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  cursor: pointer;
  margin-left: 10px;
  margin-top: 125px;
`;

const GridLabel = styled(Typography)(() => ({
  width: "250px",
  color: " #00838c",
  fontSize: "18px",
  marginTop: "10px",
  marginBottom: "10px",
  marginLeft: "15px",
  fontFamily: theme.fonts.primaryFontSemiBold,
}));

const GridButtons = styled.div`
  width: auto;
  margin-left: 15px;
  margin-top: 5px;
  @media ${theme.breakpoints.md_up} {
    width: 30%;
    padding-top: 50px;
  }
`;

const ListContainer = styled.div`
  width: 250;
  margin-top: 10px;
  margin-left: 20px;
  font-size: 14px;
  color: ${COLORS.COLOR_DARK} !important;
  font-family: ${theme.fonts.primaryFontSemiBold};
  // /* min-height: 89px; */
  border-radius: 6px;
  height: 110px;
  overflow: auto;
  border: solid 0.5px #e1e3ee;
  background-color: #ffffff;
  outline: none;
  ${({ error }) =>
    error &&
    css`
      border: solid 0.5px #f44336;
      :hover {
        border: solid 0.5px #f44336;
      }
    `}
`;
